module.exports = __webpack_public_path__ + "img/wy.e4399553.png";